import React from 'react';
//import { useRouter } from 'next/router';

const Tag = ({ value, userClickOnTagHandler }) => (
  <div className="tag" onClick={(e) => userClickOnTagHandler(e, value)}>
    {value}
  </div>
);
export default Tag;
